/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for AccountingAccountResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetAccountingAccountByIdResponse, AccountType, GetAccountingAccountsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class AccountingAccountResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getAccountingAccountById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetAccountingAccountByIdResponse, unknown> & { defaultValue: NoInfer<GetAccountingAccountByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetAccountingAccountByIdResponse>;
    getAccountingAccountById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetAccountingAccountByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetAccountingAccountByIdResponse | undefined>;
    getAccountingAccountById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetAccountingAccountByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetAccountingAccountByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/AccountingAccount/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getAccountingAccounts(searchTerm: Signal<string | null | undefined> | string | null | undefined, accountTypes: Signal<(Array<AccountType> | null) | undefined> | (Array<AccountType> | null) | undefined, resourceOptions: HttpResourceOptions<GetAccountingAccountsResponse, unknown> & { defaultValue: NoInfer<GetAccountingAccountsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetAccountingAccountsResponse>;
    getAccountingAccounts(searchTerm?: Signal<string | null | undefined> | string | null, accountTypes?: Signal<(Array<AccountType> | null) | undefined> | (Array<AccountType> | null), resourceOptions?: HttpResourceOptions<GetAccountingAccountsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetAccountingAccountsResponse | undefined>;
    getAccountingAccounts(searchTerm?: Signal<string | null | undefined> | string | null, accountTypes?: Signal<(Array<AccountType> | null) | undefined> | (Array<AccountType> | null), resourceOptions?: HttpResourceOptions<GetAccountingAccountsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetAccountingAccountsResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            const accountTypesValue = typeof accountTypes === 'function' ? accountTypes() : accountTypes;
            if (accountTypesValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, accountTypesValue, 'accountTypes');
            }
            return {
                url: `${this.basePath}/AccountingAccount`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
